import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import {
    Controller,
    FormProvider,
    useFieldArray,
    useForm,
} from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import moment from "moment/moment";
import Select from "react-select";
import MissingPODropdown from "./MissingPODropdown";
import AllocateBatchModal from "./AllocateBatchModal";

const IssueSlip = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [itemIds, setItemIds] = useState([]);
    const privileges = secureLocalStorage.getItem("privileges");
    const userId = secureLocalStorage.getItem("userID");
    const requisitionInfo = location.state?.data;
    const { action, date, machine } = location.state;

    const {
        useFetch: useFetchRequisitionSlips,
        useCreate: useUpdateRequisitionSlips,
    } = useAPIQuery({
        key: `requisition-slip-${requisitionInfo?.id}`,
        endpoint: "/api/requisitions/",
    });
    const {
        data: requisitionSlips,
        isLoading: requisitionSlipsLoading,
        isError: errorLoadingRequisitionSlips,
        isFetching: fetchingRequisitionSlips,
    } = useFetchRequisitionSlips({
        params: {
            c:
                action === "issue_slip_for_date" || "issue_slip_for_machine"
                    ? ""
                    : "daily_plan_id",
            q:
                action === "issue_slip_for_date" || "issue_slip_for_machine"
                    ? ""
                    : requisitionInfo?.id,
            action:
                action === "issue_slip_for_date"
                    ? "date_wise_slip"
                    : action === "issue_slip_for_machine"
                    ? "machine_wise_slip"
                    : "daily_plan_wise_slip",

            date: date,
            machine_id: machine,
            daily_plan_id: location.state?.data?.id,
        },
        abortOnNewRequest: true,
        retry: 3,
    });

    const methods = useForm({
        mode: "onBlur",
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
    } = methods;

    const { slips, append, remove } = useFieldArray({
        control,
        name: `slip`,
    });

    console.log(requisitionSlips);
    const { mutate: updateRequisitionSlips, isPending } =
        useUpdateRequisitionSlips({
            params: {
                action: "approval",
                department:
                    privileges.includes("requesting_dept_slip_update") &&
                    privileges.includes("store_dept_slip_update")
                        ? "both"
                        : privileges.includes("requesting_dept_slip_update")
                        ? "daily_plan"
                        : "store",
            },
            errorMessageFromServer: true,
            onSuccess: (res) => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res?.message,
                }).then(() => {
                    console.log("back");
                    navigate(-1);
                });
                reset();
            },
        });
    const { useFetch: useFetchBatches } = useAPIQuery({
        key: "api/batch",
        endpoint: "api/batch",
    });
    const { data: batches, isLoading: loadingBatches } = useFetchBatches({
        params: {
            items: itemIds?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
        enabled: !!itemIds,
    });
    const onSubmit = (data) => {
        console.log(data);
        let res = [];
        if (
            privileges.includes("store_dept_slip_update") &&
            privileges.includes("requesting_dept_slip_update")
        ) {
            res = data?.slip?.map((d) => ({
                id: Number(d?.id),
                approved_by_requesting_department:
                    d?.approvedByRequestingDepartment
                        ? d?.approvedByRequestingDepartment
                        : false,
                approved_by_allotting_department:
                    d?.approvedByAllottingDepartment
                        ? d?.approvedByAllottingDepartment
                        : false,
                received_quantity: Number(d?.receivedQuantity),
                batch: d?.batches?.map((batch) => batch?.value),
            }));
        } else if (privileges.includes("requesting_dept_slip_update")) {
            res = data?.slip?.map((d) => ({
                id: Number(d?.id),
                approved_by_requesting_department:
                    d?.approvedByRequestingDepartment
                        ? d?.approvedByRequestingDepartment
                        : false,
            }));
        } else if (privileges.includes("store_dept_slip_update")) {
            res = data?.slip?.map((d) => ({
                id: Number(d?.id),
                approved_by_allotting_department:
                    d?.approvedByAllottingDepartment
                        ? d?.approvedByAllottingDepartment
                        : false,
                received_quantity: Number(d?.receivedQuantity),
                batch: d?.batches?.map((batch) => batch?.value),
            }));
        }
        if (res?.length > 0) {
            // updateRequisitionSlips({
            //     data: {
            //         bulk_upload: res,
            //         updated_by: userId,
            //     },
            // });
        } else {
            Swal.fire({
                icon: "warning",
                title: "No data to update",
                text: `It seems there is no data to update`,
            });
        }
    };
    useEffect(() => {
        if (requisitionSlips) {
            setItemIds(
                requisitionSlips?.results?.data?.map((rs) => rs?.item?.id)
            );
        }
    }, [requisitionSlips]);

    if (!requisitionInfo) return <Error />;
    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Issue Slip
                        </h3>
                    </div>
                </div>
            </div>
            <div className="card">
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="card-inner p-0 m-0">
                            <div className="card-body table-responsive p-0 pb-0">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-center"
                                            >
                                                Green Edge Venture
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-center"
                                            >
                                                Issue slip
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-end"
                                            >
                                                Date:{" "}
                                                {moment(
                                                    requisitionInfo?.updated_at
                                                ).format("DD-MM-YYYY")}
                                            </th>
                                        </tr>
                                        <tr>
                                            {privileges.includes(
                                                "requesting_dept_slip_update"
                                            ) && (
                                                <th
                                                    colSpan={5}
                                                    className="text-center"
                                                >
                                                    Requesting departmnent
                                                </th>
                                            )}
                                            {privileges.includes(
                                                "store_dept_slip_update"
                                            ) && (
                                                <th
                                                    colSpan={6}
                                                    className="text-center"
                                                >
                                                    Store Department
                                                </th>
                                            )}
                                        </tr>
                                        <tr>
                                            {privileges.includes(
                                                "requesting_dept_slip_update"
                                            ) && (
                                                <>
                                                    <th className="text-center">
                                                        Material
                                                    </th>
                                                    <th className="text-center">
                                                        Batch No
                                                    </th>
                                                </>
                                            )}
                                            <th className="text-center">
                                                Req. Qty
                                            </th>
                                            {privileges.includes(
                                                "requesting_dept_slip_update"
                                            ) && (
                                                <>
                                                    <th className="text-center">
                                                        Total issued quantity
                                                    </th>
                                                    <th className="text-center">
                                                        Approve
                                                    </th>
                                                </>
                                            )}
                                            {privileges.includes(
                                                "store_dept_slip_update"
                                            ) && (
                                                <>
                                                    <th className="text-center">
                                                        Issue Qty
                                                    </th>
                                                    {privileges.includes(
                                                        "store_dept_slip_update"
                                                    ) ? (
                                                        <th className="text-center">
                                                            Available Stock
                                                        </th>
                                                    ) : null}
                                                    <th className="text-center">
                                                        Batches
                                                    </th>
                                                    <th className="text-center">
                                                        UOM
                                                    </th>
                                                    <th className="text-center">
                                                        Batch No
                                                    </th>
                                                    <th className="text-center">
                                                        Issue
                                                    </th>
                                                </>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {requisitionSlips?.results?.data
                                            ?.length !== 0 &&
                                        !errorLoadingRequisitionSlips ? (
                                            <>
                                                {requisitionSlips?.results?.data?.map(
                                                    (rs, index) => (
                                                        <tr key={index}>
                                                            <input
                                                                type="text"
                                                                style={{
                                                                    display:
                                                                        "none",
                                                                }}
                                                                defaultValue={
                                                                    rs?.id
                                                                }
                                                                {...register(
                                                                    `slip.${index}.id`
                                                                )}
                                                            />
                                                            {privileges.includes(
                                                                "requesting_dept_slip_update"
                                                            ) && (
                                                                <>
                                                                    <td className="text-center">
                                                                        {
                                                                            rs
                                                                                ?.item
                                                                                ?.item_name
                                                                        }
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {
                                                                            rs
                                                                                ?.daily_plan
                                                                                ?.daily_plan_code
                                                                        }
                                                                    </td>
                                                                </>
                                                            )}
                                                            <td className="text-center">
                                                                {
                                                                    rs?.requested_quantity
                                                                }
                                                            </td>
                                                            {privileges.includes(
                                                                "requesting_dept_slip_update"
                                                            ) && (
                                                                <>
                                                                    <td className="text-center">
                                                                        <span className="fs-8 text-info">
                                                                            {
                                                                                rs?.received_quantity
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span
                                                                            className="text-success"
                                                                            style={{
                                                                                display:
                                                                                    rs?.approved_by_requesting_department ===
                                                                                    1
                                                                                        ? "block"
                                                                                        : "none",
                                                                            }}
                                                                        >
                                                                            Approved
                                                                        </span>
                                                                        <input
                                                                            type="checkbox"
                                                                            defaultChecked={
                                                                                rs?.approved_by_requesting_department ===
                                                                                1
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            {...register(
                                                                                `slip.${index}.approvedByRequestingDepartment`
                                                                            )}
                                                                            disabled={() => {
                                                                                if (
                                                                                    privileges.includes(
                                                                                        "store_dept_slip_update"
                                                                                    ) &&
                                                                                    privileges.includes(
                                                                                        "requesting_dept_slip_update"
                                                                                    )
                                                                                ) {
                                                                                    return false;
                                                                                }
                                                                                return rs?.approved_by_allotting_department !==
                                                                                    1
                                                                                    ? true
                                                                                    : false ||
                                                                                          !privileges.includes(
                                                                                              "requesting_dept_slip_update"
                                                                                          );
                                                                            }}
                                                                            style={{
                                                                                display:
                                                                                    rs?.approved_by_requesting_department ===
                                                                                    1
                                                                                        ? "none"
                                                                                        : "block",
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </>
                                                            )}
                                                            {privileges.includes(
                                                                "store_dept_slip_update"
                                                            ) && (
                                                                <>
                                                                    <td className="text-center">
                                                                        {rs?.received_quantity >
                                                                            0 &&
                                                                        rs?.received_quantity <
                                                                            rs?.requested_quantity ? (
                                                                            <span className="fs-8 text-success">
                                                                                previously
                                                                                issued
                                                                                quantity:{" "}
                                                                                {
                                                                                    rs?.received_quantity
                                                                                }
                                                                            </span>
                                                                        ) : null}
                                                                    </td>
                                                                    {privileges.includes(
                                                                        "store_dept_slip_update"
                                                                    ) ? (
                                                                        <td className="text-center">
                                                                            {
                                                                                rs
                                                                                    ?.item
                                                                                    ?.stock_quantity
                                                                            }
                                                                        </td>
                                                                    ) : null}

                                                                    <td>
                                                                        {rs?.item?.category?.toLowerCase() ===
                                                                        "raw material" ? (
                                                                            <div className="d-flex justify-content-center align-items-center">
                                                                                <div>
                                                                                    <AllocateBatchModal
                                                                                        row={
                                                                                            rs
                                                                                        }
                                                                                        itemIds={
                                                                                            itemIds
                                                                                        }
                                                                                        index={
                                                                                            index
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                <div>
                                                                                    <MissingPODropdown
                                                                                        info={
                                                                                            batches
                                                                                                ?.results
                                                                                                ?.info?.[
                                                                                                rs
                                                                                                    ?.item
                                                                                                    ?.id
                                                                                            ]
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            "Not A Raw Material"
                                                                        )}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {
                                                                            rs
                                                                                ?.item
                                                                                ?.uom
                                                                        }
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {
                                                                            rs
                                                                                ?.daily_plan
                                                                                ?.daily_plan_code
                                                                        }
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span
                                                                            className="text-success"
                                                                            style={{
                                                                                display:
                                                                                    rs?.approved_by_allotting_department ===
                                                                                    1
                                                                                        ? "block"
                                                                                        : "none",
                                                                            }}
                                                                        >
                                                                            Issued
                                                                        </span>
                                                                        <input
                                                                            type="checkbox"
                                                                            defaultChecked={
                                                                                rs?.approved_by_allotting_department ===
                                                                                1
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            {...register(
                                                                                `slip.${index}.approvedByAllottingDepartment`
                                                                            )}
                                                                            disabled={
                                                                                !privileges.includes(
                                                                                    "store_dept_slip_update"
                                                                                )
                                                                            }
                                                                            style={{
                                                                                display:
                                                                                    rs?.approved_by_allotting_department ===
                                                                                    1
                                                                                        ? "none"
                                                                                        : "block",
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    )
                                                )}
                                            </>
                                        ) : !(
                                              requisitionSlipsLoading ||
                                              fetchingRequisitionSlips
                                          ) ? (
                                            <tr>
                                                <td
                                                    colSpan={8}
                                                    className="text-center"
                                                >
                                                    {errorLoadingRequisitionSlips
                                                        ? "Error loading data"
                                                        : "No data to display"}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {(requisitionSlipsLoading ||
                                            fetchingRequisitionSlips) && (
                                            <tr>
                                                <td
                                                    colSpan={9}
                                                    className="text-center"
                                                >
                                                    Loading data...
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 m-3 ">
                                <div className="form-group">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-light me-2"
                                        id="submit-button-backbutton"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>
                                    {isPending ? (
                                        <button
                                            type="button"
                                            id="button-typemaster-loading"
                                            className="btn btn-md text-dark"
                                            disabled
                                        >
                                            Loading...
                                        </button>
                                    ) : (
                                        <>
                                            {privileges.includes(
                                                "store_dept_slip_update"
                                            ) ||
                                            privileges.includes(
                                                "requesting_dept_slip_update"
                                            ) ? (
                                                <button
                                                    type="submit"
                                                    className="btn btn-md btn-primary"
                                                    id="submit-button-create-typemaster"
                                                    disabled={
                                                        requisitionSlipsLoading ||
                                                        errorLoadingRequisitionSlips ||
                                                        requisitionSlips
                                                            ?.results?.data
                                                            ?.length === 0
                                                    }
                                                >
                                                    Submit
                                                </button>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </>
    );
};

export default IssueSlip;
